import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SYNCHRO_GET_API_HABILITATIONS = "SYNCHRO_GET_API_HABILITATIONS";
